import { getRealIpToken } from '@pikpak/pp-js-bridge'
import { getDomain } from '~/utils'
import apiPrefix from '~/utils/apiPrefix'

export const isDev = process.env.NODE_ENV === 'development'

const {
  // 云盘相关接口
  PP_DRIVE_API,
  // 账号相关接口
  PP_USER_API,
  PP_CONFIG_API,
} = apiPrefix(getDomain())

export { PP_CONFIG_API, PP_DRIVE_API, PP_USER_API }

export const DRIVE_API_V1 = `${PP_DRIVE_API}/drive/v1` as const
export const VIP_API_V1 = `${PP_DRIVE_API}/vip/v1` as const
export const CONFIG_API_V1 = `${PP_CONFIG_API}/config/v1` as const
export const ADMIN_API_V1 = `${PP_DRIVE_API}/audit.admin/v1` as const

export const getRtcToken = async () => {
  if (import.meta.client) return getRealIpToken()
  return undefined
}
